(function () {
  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');

  const messages = {
    verd: isEnglish
      ? 'EL VERD DEL POAIG has a minimum order of 2 olieras when the cart does not include EL MIL DEL POAIG. With at least 1 EL MIL, you may add 1 EL VERD.'
      : 'EL VERD DEL POAIG tiene un mínimo de 2 olieras cuando el carrito no incluye EL MIL DEL POAIG. Con al menos 1 EL MIL, puedes añadir 1 EL VERD.',
    carmen: isEnglish
      ? 'CARMEN DEL POAIG has a minimum order of 6 bottles when the cart includes neither EL MIL DEL POAIG nor 2 EL VERD DEL POAIG. With at least 1 EL MIL or 2 EL VERD, you may add CARMEN from 1 bottle.'
      : 'CARMEN DEL POAIG tiene un mínimo de 6 botellas cuando el carrito no incluye EL MIL DEL POAIG ni 2 EL VERD DEL POAIG. Con al menos 1 EL MIL o 2 EL VERD, puedes añadir CARMEN desde 1 botella.',
    complement: isEnglish
      ? 'EL POAIG accessories are not currently available for purchase.'
      : 'Los complementos de EL POAIG no están disponibles para la compra en este momento.',
    unavailable: isEnglish
      ? 'We could not verify the order conditions. Please try again before continuing.'
      : 'No hemos podido verificar las condiciones del pedido. Inténtalo de nuevo antes de continuar.',
  };

  function getCart() {
    const root = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    return fetch(`${root}.js`, { credentials: 'same-origin' }).then((response) => {
      if (!response.ok) throw new Error('Cart validation request failed');
      return response.json();
    });
  }

  function quantitiesFromItems(items) {
    const complementHandles = new Set(['delantal', 'madera-el-poaig', 'vaso-de-cata-el-poaig']);
    return items.reduce(
      (quantities, item) => {
        const handle = item.handle || item.product_handle;
        const quantity = Number(item.quantity) || 0;

        if (handle === 'el-mil-02-olive-oil') quantities.mil += quantity;
        else if (handle === 'el-verd') quantities.verd += quantity;
        else if (handle === 'carmen-del-poaig') quantities.carmen += quantity;
        else if (complementHandles.has(handle)) quantities.complements += quantity;

        return quantities;
      },
      { mil: 0, verd: 0, carmen: 0, complements: 0 }
    );
  }

  function validateItems(items) {
    const quantities = quantitiesFromItems(items);

    if (quantities.mil === 0 && quantities.verd > 0 && quantities.verd < 2) {
      return { valid: false, message: messages.verd };
    }

    if (
      quantities.mil === 0 &&
      quantities.verd < 2 &&
      quantities.carmen > 0 &&
      quantities.carmen < 6
    ) {
      return { valid: false, message: messages.carmen };
    }

    if (quantities.complements > 0) {
      return { valid: false, message: messages.complement };
    }

    return { valid: true, message: '' };
  }

  function projectedItems(cart, productHandle, quantityToAdd) {
    const items = cart.items.map((item) => ({ handle: item.handle, quantity: item.quantity }));
    const existing = items.find((item) => item.handle === productHandle);

    if (existing) existing.quantity += quantityToAdd;
    else items.push({ handle: productHandle, quantity: quantityToAdd });

    return items;
  }

  function getProductHandle(form) {
    return (
      form.dataset.productHandle ||
      form.querySelector('[data-product-handle]')?.dataset.productHandle ||
      document.querySelector('link[rel="canonical"]')?.href.match(/\/products\/([^/?#]+)/)?.[1] ||
      ''
    );
  }

  function showProductMessage(form, message) {
    let region = form.querySelector('[data-poaig-purchase-rule]');
    if (!region) {
      region = document.createElement('p');
      region.className = 'poaig-purchase-rule';
      region.dataset.poaigPurchaseRule = '';
      region.setAttribute('role', 'alert');
      const submitButton = form.querySelector('[type="submit"][name="add"], [type="submit"]');
      if (submitButton) submitButton.before(region);
      else form.append(region);
    }

    region.textContent = message;
    region.hidden = false;
    const quantityInput = form.querySelector('[name="quantity"]');
    if (quantityInput) quantityInput.setAttribute('aria-invalid', 'true');
  }

  function clearProductMessage(form) {
    const region = form.querySelector('[data-poaig-purchase-rule]');
    if (region) {
      region.textContent = '';
      region.hidden = true;
    }
    const quantityInput = form.querySelector('[name="quantity"]');
    if (quantityInput) quantityInput.removeAttribute('aria-invalid');
  }

  function getCartMessageRegion() {
    const cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (!cartBlocks) return null;

    let region = cartBlocks.querySelector('[data-poaig-cart-rule]');
    if (!region) {
      region = document.createElement('p');
      region.className = 'poaig-cart-rule-message';
      region.dataset.poaigCartRule = '';
      region.setAttribute('role', 'alert');
      const checkout = cartBlocks.querySelector('#checkout, [name="checkout"]');
      if (checkout?.parentElement) checkout.parentElement.before(region);
      else cartBlocks.prepend(region);
    }
    return region;
  }

  function renderCartValidation(result, itemCount) {
    if (Number.isFinite(itemCount)) {
      document.querySelectorAll('.poaig-cart span').forEach(function (count) {
        count.textContent = String(itemCount);
      });
    }

    const region = getCartMessageRegion();
    const checkout = document.querySelector('#checkout, button[name="checkout"]');
    const acceleratedCheckout = document.querySelector('.additional-checkout-buttons');
    document.body.classList.toggle('poaig-cart-rules-invalid', !result.valid);

    if (checkout) {
      checkout.disabled = !result.valid || itemCount === 0;
      checkout.setAttribute('aria-describedby', 'poaig-cart-rule-message');
    }

    if (acceleratedCheckout) {
      acceleratedCheckout.hidden = !result.valid || itemCount === 0;
      acceleratedCheckout.setAttribute('aria-hidden', String(!result.valid || itemCount === 0));
    }

    if (region) {
      region.id = 'poaig-cart-rule-message';
      region.textContent = result.message;
      region.hidden = result.valid;
    }
  }

  function syncCartQuantityInputs(cart) {
    cart.items.forEach((item, index) => {
      const line = index + 1;
      const inputs = document.querySelectorAll(`#Quantity-${line}, #Drawer-quantity-${line}`);
      inputs.forEach((input) => {
        input.value = item.quantity;
        input.setAttribute('value', item.quantity);
      });
    });
  }

  async function refreshCartValidation() {
    if (!document.body.classList.contains('poaig-cart-page')) return;
    try {
      const cart = await getCart();
      const result = validateItems(cart.items);
      if (!result.valid) syncCartQuantityInputs(cart);
      renderCartValidation(result, cart.item_count);
    } catch (error) {
      renderCartValidation({ valid: false, message: messages.unavailable });
    }
  }

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const isProductForm = form.matches('form[action*="/cart/add"]') && form.querySelector('[name="id"]');
      const isCheckoutForm = form.id === 'cart' && (!event.submitter || event.submitter.name === 'checkout');
      if (!isProductForm && !isCheckoutForm) return;

      if (form.dataset.poaigValidationPassed === 'true') {
        delete form.dataset.poaigValidationPassed;
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        const cart = await getCart();
        const validation = isProductForm
          ? validateItems(
              projectedItems(
                cart,
                getProductHandle(form),
                Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1)
              )
            )
          : validateItems(cart.items);

        if (!validation.valid) {
          if (isProductForm) showProductMessage(form, validation.message);
          else renderCartValidation(validation, cart.item_count);
          return;
        }

        if (isProductForm) clearProductMessage(form);
        else renderCartValidation(validation, cart.item_count);

        form.dataset.poaigValidationPassed = 'true';
        if (typeof form.requestSubmit === 'function' && event.submitter) form.requestSubmit(event.submitter);
        else form.submit();
      } catch (error) {
        if (isProductForm) showProductMessage(form, messages.unavailable);
        else renderCartValidation({ valid: false, message: messages.unavailable });
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    refreshCartValidation();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartValidation);
    }

    document.addEventListener('change', (event) => {
      if (event.target.closest('cart-items, cart-drawer-items')) {
        window.setTimeout(refreshCartValidation, 900);
      }
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('cart-remove-button, .quantity__button, a[href*="/cart/change"]')) {
        window.setTimeout(refreshCartValidation, 1200);
      }
    });
  });

  window.PoaigCartRules = { validateItems };
})();
